import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['banner', 'tagSelect']

  connect() {
    this.toggle()
  }

  toggle() {
    this.bannerTarget.classList.toggle('hidden', this.tagSelectTarget.value === 'product_quality_issue')
  }
}
